// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AssignNextTaskConfirmation-module__container {
  min-width: 552px;
  background: #ffffff;
  border-radius: 16px;
  padding: 22px 24px 32px;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.AssignNextTaskConfirmation-module__closeHeader {
  position: absolute;
  top: 22px;
  right: 24px;
  cursor: pointer;
}

.AssignNextTaskConfirmation-module__closeHeader button {
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.AssignNextTaskConfirmation-module__confirmationIcon {
  width: 74.81px;
  height: 76.89px;
}

.AssignNextTaskConfirmation-module__content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  width: 100%;
}

.AssignNextTaskConfirmation-module__textContent {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.AssignNextTaskConfirmation-module__heading {
  font-weight: 600;
  font-size: 18px;
  line-height: 1.67em;
  text-align: center;
  color: #1e2a36;
  margin: 0;
}

.AssignNextTaskConfirmation-module__description {
  font-weight: 500;
  font-size: 14px;
  line-height: 1.735em;
  text-align: center;
  color: #1e2a36;
  margin: 0;
  width: 504px;
}

.AssignNextTaskConfirmation-module__btnContainer {
  display: flex;
  flex-direction: row;
  justify-content: stretch;
  align-items: stretch;
  gap: 12px;
  width: 497px;
}

.AssignNextTaskConfirmation-module__submitAndGoBackBtn {
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 8px;
  padding: 14px 20px;
  border-radius: 70px;
  border: 1px solid #263643;
  background: transparent;
  font-weight: 600;
  font-size: 14px;
  line-height: 1.219em;
  letter-spacing: 4%;
  text-transform: uppercase;
  text-align: center;
  color: #263643;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.AssignNextTaskConfirmation-module__submitAndGoBackBtn:hover {
  background-color: rgba(38, 54, 67, 0.05);
}

.AssignNextTaskConfirmation-module__assignNextTaskBtn {
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 10px;
  padding: 14px 64px;
  border-radius: 56px;
  border: none;
  background-color: #263643;
  font-weight: 600;
  font-size: 14px;
  line-height: 1.219em;
  letter-spacing: 4%;
  text-transform: uppercase;
  text-align: center;
  color: #ffffff;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.AssignNextTaskConfirmation-module__assignNextTaskBtn:hover {
  background-color: #1e2a36;
}
`, "",{"version":3,"sources":["webpack://./src/modals/assignnexttaskconfirmation/AssignNextTaskConfirmation.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,8CAA8C;EAC9C,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;EACd,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,wBAAwB;EACxB,oBAAoB;EACpB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".container {\n  min-width: 552px;\n  background: #ffffff;\n  border-radius: 16px;\n  padding: 22px 24px 32px;\n  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n}\n\n.closeHeader {\n  position: absolute;\n  top: 22px;\n  right: 24px;\n  cursor: pointer;\n}\n\n.closeHeader button {\n  background: none;\n  border: none;\n  font-size: 18px;\n  cursor: pointer;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.confirmationIcon {\n  width: 74.81px;\n  height: 76.89px;\n}\n\n.content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 24px;\n  width: 100%;\n}\n\n.textContent {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n}\n\n.heading {\n  font-weight: 600;\n  font-size: 18px;\n  line-height: 1.67em;\n  text-align: center;\n  color: #1e2a36;\n  margin: 0;\n}\n\n.description {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 1.735em;\n  text-align: center;\n  color: #1e2a36;\n  margin: 0;\n  width: 504px;\n}\n\n.btnContainer {\n  display: flex;\n  flex-direction: row;\n  justify-content: stretch;\n  align-items: stretch;\n  gap: 12px;\n  width: 497px;\n}\n\n.submitAndGoBackBtn {\n  flex: 1;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  padding: 14px 20px;\n  border-radius: 70px;\n  border: 1px solid #263643;\n  background: transparent;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 1.219em;\n  letter-spacing: 4%;\n  text-transform: uppercase;\n  text-align: center;\n  color: #263643;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.submitAndGoBackBtn:hover {\n  background-color: rgba(38, 54, 67, 0.05);\n}\n\n.assignNextTaskBtn {\n  flex: 1;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  padding: 14px 64px;\n  border-radius: 56px;\n  border: none;\n  background-color: #263643;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 1.219em;\n  letter-spacing: 4%;\n  text-transform: uppercase;\n  text-align: center;\n  color: #ffffff;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.assignNextTaskBtn:hover {\n  background-color: #1e2a36;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `AssignNextTaskConfirmation-module__container`,
	"closeHeader": `AssignNextTaskConfirmation-module__closeHeader`,
	"confirmationIcon": `AssignNextTaskConfirmation-module__confirmationIcon`,
	"content": `AssignNextTaskConfirmation-module__content`,
	"textContent": `AssignNextTaskConfirmation-module__textContent`,
	"heading": `AssignNextTaskConfirmation-module__heading`,
	"description": `AssignNextTaskConfirmation-module__description`,
	"btnContainer": `AssignNextTaskConfirmation-module__btnContainer`,
	"submitAndGoBackBtn": `AssignNextTaskConfirmation-module__submitAndGoBackBtn`,
	"assignNextTaskBtn": `AssignNextTaskConfirmation-module__assignNextTaskBtn`
};
export default ___CSS_LOADER_EXPORT___;
